'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.getOneByHandle = getOneByHandle;
exports.getCollectionServer = getCollectionServer;

var _lib = require('helpers/lib');

var _ApiServer = require('helpers/ApiServer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ===========================================
=            Collections Reducer            =
=========================================== */
var LOAD = 'lookme/collections/LOAD';
var LOAD_SUCCESS = 'lookme/collections/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/collections/LOAD_FAIL';
var GET_ONE = 'lookme/collections/GET_ONE';
var GET_ONE_SUCCESS = 'lookme/collections/GET_ONE_SUCCESS';
var GET_ONE_FAIL = 'lookme/collections/GET_ONE_FAIL';

var initialState = {
  loaded: false,
  loading: false,
  lists: null,
  loadedDetail: false,
  loadingDetail: false,
  collection: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        lists: action.result && action.result.data || [],
        total: action.result && action.result.total || 0,
        pageSize: action.result && action.result.pageSize || 4,
        errorsLoad: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        errorsLoad: action.error
      });
    case GET_ONE:
      return (0, _extends3.default)({}, state, {
        loadingDetail: true,
        loadedDetail: false
      });
    case GET_ONE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingDetail: false,
        loadedDetail: true,
        collection: action.result,
        errorsLoadDetail: null
      });
    case GET_ONE_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingDetail: false,
        loadedDetail: true,
        errorsLoadDetail: action.error
      });
    default:
      return state;
  }
}

/* ----------  actions  ---------- */

function isLoaded(globalState) {
  return globalState.collections && globalState.collections.lists;
}

function load(filter) {
  var query = {
    page: 1,
    pageSize: 4,
    sort: 'updatedAt',
    sortTo: true
  };
  (0, _assign2.default)(query, filter);
  var url = (0, _lib.parseUrl)(query);
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/collection/load?' + url);
    }
  };
}

function getOneByHandle(handle) {
  return {
    types: [GET_ONE, GET_ONE_SUCCESS, GET_ONE_FAIL],
    promise: function promise(client) {
      return client.get('/collection/getOneByHandle/' + handle);
    }
  };
}
function getCollectionServer(handle) {
  return {
    types: [GET_ONE, GET_ONE_SUCCESS, GET_ONE_FAIL],
    promise: function promise() {
      return _ApiServer.server.get('/collection/getOneByHandle/' + handle);
    }
  };
}
/* =====  End of Collections Reducer  ====== */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/collections.js
// module id = 124
// module chunks = 0